export default __webpack_public_path__ + "static/summer_containers62-2251e4dec7c85cf226a377bd782d9d95.webp";